import React from 'react'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'

import Button from '@material-ui/core/Button'
import Chip from '@material-ui/core/Chip'
import Avatar from '@material-ui/core/Avatar'
import ButtonGroup from '@material-ui/core/ButtonGroup'

// import LibraryAddIcon from '@material-ui/icons/LibraryAdd'
import PostAddIcon from '@material-ui/icons/PostAdd'
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted'

import clsx from 'clsx'

// const vault = require('../../../../assets/images/vault-icon.png')
/**
 * Returns word vault main form
 */
const WordVaultMain = ({ unitName, setVaultForm, handleNewWord, wordCount, useStyles }) => {
  const classes = useStyles()

  return (
    <>
      <Card>
        <CardContent>
          <Grid container direction='column' spacing={4}>

            <Grid container item direction='row' spacing={2} justify='center'>
              <Grid item container direction='column' xs={9} spacing={2} justify='space-evenly'>
                <Grid item>
                  <Typography component='h5' variant='h5' className='font-weight-bold text-break'>
                    {unitName.replace(/_/g, ' ')} Word Vault
                  </Typography>
                </Grid>

                <Grid item>
                  <Chip
                    label={
                      <>
                        <Grid container direction='row' className='w-100'>
                          <Grid item xs={8} container alignContent='center'>
                            <Typography
                              variant='h6'
                              component='h6'
                            >
                              Custom Words:
                            </Typography>
                          </Grid>

                          <Grid item xs={4} container justify='flex-end'>

                            <Avatar variant='circle' className={clsx(classes.enabledAvatar, wordCount === 0 && classes.disabledAvatar)}>
                              <Grid container direction='column' alignItems='center' justify='center'>
                                <Grid item>
                                  <Typography variant='h5' component='h5' align='center' className='font-weight-bold'>
                                    {wordCount}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Avatar>

                          </Grid>
                        </Grid>
                      </>
                    }
                    className={`${classes.vaultChip}`}
                    classes={{
                      label: classes.label
                    }}
                  />
                </Grid>
              </Grid>

              <Grid item xs={3} container justify='flex-end'>
                <CardMedia
                  // src={vault}
                  image={require('../../../../assets/images/vault-icon.png')}
                  // title='SXP-vault'
                  className={classes.vaultImg}
                />
              </Grid>
            </Grid>

            <Grid container item direction='row' justify='center'>
              <ButtonGroup className={classes.vaultActions}>
                <Button
                  variant='contained'
                  className={classes.listBtn}
                  onClick={() => { setVaultForm('list') }}
                  disabled={wordCount === 0}
                >
                  <FormatListBulletedIcon fontSize='large' />
                  <Typography variant='h6' component='h6' className='w-75 font-weight-bold'>
                    View Custom Words
                  </Typography>
                </Button>
                <Button variant='contained' className={classes.newBtn} onClick={handleNewWord}>
                  <PostAddIcon fontSize='large' />
                  <Typography variant='h6' component='h6' className='w-75 font-weight-bold'>
                    New Custom Word
                  </Typography>
                </Button>
              </ButtonGroup>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}

export default WordVaultMain
